<template>
  <form @submit.prevent="login()">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <div class="md-layout md-gutter">
          <div class="md-layout-item d-size-100">
            <h4 class="title">Iniciar Sesion</h4>
          </div>
        </div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Usuario</label>
              <md-input v-model="usuario" type="text" required></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Contrasesdsña</label>
              <md-input v-model="password" type="password" required></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success">Ingresar</md-button>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import axios from "axios";
import Global from "../../Global";

export default {
  name: "Login",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: Global.url,
      usuario: null,
      password: null
    };
  },
  mounted() {
    if (localStorage.usertoken != null) {
      this.$router.push("/");
    }
  },
  methods: {
    login() {
      axios
      .post(this.url + "login", {
        usuario: this.usuario,
        password: this.password
      })
      .then(res => {
        if (res.status == 200 && res.data.api_token != null) {
          localStorage.setItem("usertoken", res.data.api_token);
          this.usuario = "";
          this.password = "";
          location.reload();
        }
      })
      .catch(err => {
        alert(err)
      });
    }
  }
};
</script>